import { ConsentInteractionType } from 'pkg/api/models/agreement';

export const consentInteractionTypeFor = (
	consentRequired: boolean
): ConsentInteractionType =>
	consentRequired
		? ConsentInteractionType.Required
		: ConsentInteractionType.Optional;

/**
 * Drift-detection fingerprint over an agreement's title and content. Must stay
 * byte-for-byte identical to the backend's computeAgreementFingerprint
 * (sha256hex(title + content)) — the submit flow rejects an accepted agreement
 * whose fingerprint doesn't match what the API just read, with `agreement_drifted`.
 */
export const computeContentFingerprint = async (
	title: string,
	content: string
): Promise<string> => {
	const bytes = new TextEncoder().encode(title + content);
	const digest = await crypto.subtle.digest('SHA-256', bytes);
	return Array.from(new Uint8Array(digest))
		.map((b) => b.toString(16).padStart(2, '0'))
		.join('');
};
